module.exports = __webpack_public_path__ + "img/logo_debank.fb77b782.png";